import React from "react";
import classNames from "classnames";
import styles from "./CarouselCard2Ui.module.css";
import { Icon } from "~/components";

export const CarouselCard2Ui = ({ item }) => {
  const { title, image, description, buttonLink } = item;
  const backgroundImage = `linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent 55%), url(${image})`;

  return (
    <div className={styles.item} style={{ backgroundImage }}>
      <div className={styles.title}>{title}</div>
      <p className={styles.text}>{description}</p>
      <a
        className={classNames(styles.link, "custom_click_track")}
        href={buttonLink}
        data-custom_click_track_value={`Explore|${title}|external`}
      >
        <span>Explore</span>
        <Icon name="arrowRight" />
      </a>
    </div>
  );
};
